import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface ReportNotesType {
  reportNotes?: any;
  questionId?: number;
}

export default function ReportNotes({ reportNotes }: ReportNotesType) {
  const { t } = useTranslation();

  return (
    <Box sx={{ my: 2 }}>
      {reportNotes &&
        reportNotes.length > 0 &&
        reportNotes.map((note: any) => (
          <Box key={note.id}>
            {note.version ? (
              <>
                <Typography component="span" variant="body1" fontWeight={'bold'}>
                  {t('patientNote.clinicianNote')}:
                </Typography>
                <Typography component="span" variant="body1" fontStyle={'italic'} fontWeight={500}>
                  {` ${t('patientNote.noteVersion', { version: note.version })} ${
                    note.interviewerName ||
                    note.interviewer.lastName + ', ' + note.interviewer.firstName
                  }`}
                </Typography>
                <Typography
                  sx={{ marginLeft: '2rem', whiteSpace: 'pre-wrap' }}
                  variant="body1"
                  fontWeight={500}
                >
                  {note?.noteContent}
                </Typography>
              </>
            ) : (
              <>
                <Typography variant="body1" fontWeight={'bold'}>
                  {t('patientNote.clinicianNotes')}
                </Typography>
                <Typography
                  sx={{ marginLeft: '2rem', whiteSpace: 'pre-wrap' }}
                  fontWeight={500}
                  variant="body1"
                >
                  {note?.noteContent}
                </Typography>
              </>
            )}
          </Box>
        ))}
    </Box>
  );
}
